module.exports = __webpack_public_path__ + "static/media/membership-card.36fee4bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/account/assets/images/membership-card.png
// module id = 1256
// module chunks = 2